/**
 * Normalize phone number to a consistent E.164-like format for existing SMS flows.
 * Current behavior preserves the existing US-centric rules from smsCheckInService.
 *
 * @param {string} phone
 * @returns {string}
 */
export function normalizePhoneNumber(phone) {
  if (!phone || typeof phone !== 'string') return '';

  // Remove all non-digit characters except leading +
  let normalized = phone.replace(/[^\d+]/g, '');

  // Ensure US numbers have +1 prefix
  if (normalized.length === 10) {
    normalized = `+1${normalized}`;
  } else if (normalized.length === 11 && normalized.startsWith('1')) {
    normalized = `+${normalized}`;
  }

  return normalized;
}
